<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="weeklyScheduleForm">
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputShortTextWidth()" id="mtma-contact-add-input-name"
							formControlName="Name" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'NAME' | translate }}" maxlength="40" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<ng-container formArrayName="weekDays">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="manageRespStylewithError(this.f.weekDays, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.weekDays, 'label')">{{ 'WEEK_DAYS' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.weekDays, 'borderInput')">
							<p-checkbox *ngFor="let day of daysOfWeek; let i = index" [formControlName]="i" [binary]="true"
								label="{{ day.Name | translate }}"
								class="ml-4 mt-2" [class]="showErrorRequiredCheckBox(this.f.weekDays)">
							</p-checkbox>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.weekDays)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'WEEK_DAYS_REQUIRE' | translate }}</small>
				</ng-container>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.startTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="startTime" appendTo="body"
							timeOnly="true" [ngClass]="dynamicInputShortTextWidth()"
							[styleClass]="dynamicInputShortTextWidth()" inputStyleClass="pl-6 sm:pl-5 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.startTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="endTime" appendTo="body" timeOnly="true"
							[ngClass]="dynamicInputShortTextWidth()" [styleClass]="dynamicInputShortTextWidth()"
							inputStyleClass="pl-6 sm:pl-5 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.endTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'PERMISSIONS_DATE_WARNING_INVALID' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>